import React, { useRef, useState, useEffect } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import axios from "axios";
import {
  formatMoneda,
  validaMonto,
  seleccionarCampo,
  round,
  validarCantidad,
} from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import CatalogoProductoExistencia from "../../catalogos/catalogoProductoExistencia";
import CatalogoProducto from "../../catalogos/catalogoProducto";
import { ModalEditarProductosOperacion } from "./modalEditarProductoporOpe";

export const IncluirProducOper = (props) => {
  const token = sessionStorage.getItem("jwtToken");
  const op = require("../../../public/modulos/datos");
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));

  /*  variables de referencias */
  const btnCancelar = useRef();
  const btnAcepta = useRef();
  const txtIdproducto = useRef();
  const txtNombre = useRef();
  const txtCantidad = useRef();
  const txtCantidadExistente = useRef();
  const txtPrecio = useRef();
  const cmbTipoMovimiento = useRef();
  const txtFechaVenc = useRef();
  const txtFecha = useRef();
  const txtNumFactura = useRef();
  const cmbUnidad = useRef();
  const txtCosto = useRef();

  /*  variables de estados */
  const [body, setBody] = useState(null);
  const [tipoIngreso, setTipoIngreso] = useState([]);
  const [tipoIngr, setTipoIngr] = useState();
  const [catalogoediproduct, setCatalogoediproduct] = useState(false);
  const [catalogoProducto, setCatalogoProducto] = useState(false);
  const [catalogoProductoE, setCatalogoProductoE] = useState(false);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [labelFecha, setLabelFecha] = useState("FECHA:");
  const [unidadCombo, setUnidadCombo] = useState([]);
  const [tipounidadc, setTipounidadc] = useState(1);
  const [unidadc, setUnidadc] = useState();
  const [producto, setProducto] = useState({
    idproducto: null,
    codigo: null,
    cantidad: 1.0,
    cantidadE: 0.0,
    cantidadEA: 0.0,
    nombrecorto: null,
    precio: 0.0,
    preciomaxi: 0.0,
    precioofe: 0.0,
    preciomayor: 0.0,
    preciomini: 0.0,
    preciomaxialter: 0.0,
    precioofealter: 0.0,
    preciomayoralter: 0.0,
    preciominialter: 0.0,
    costoproveedor: 0.0,
    costocalculado: 0.0,
    ultimocosto: 0.0,
    costopromedio: 0.0,
    preciobs: 0.0,
    iva: 0.0,
    montoiva: 0.0,
    descuento: 0.0,
    total: 0.0,
    unidad: [],
    idunidadmedida: null,
    idunidadalterna: null,
    descripcionuni: "",
    descripcionunialt: "",
    precioconiva: 0.0,
    idmoneda: null,
    valormoneda: 0.0,
    tipounidad: null,
    tipofactor: null,
    valorfactor: 0.0,
    tipoprecio: null,
    fechavencimiento: null,
    tipomovimiento: null,
    fechatipomovimiento: null,
    numfactura: null,
    costocalculado: 0.00,
    costo: 0.00
  });
  const [habilitadoFec, setHabilitadoFec] = useState(true);
  const [habilitadoFac, setHabilitadoFac] = useState(true);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const handleInputChange = (event) => {
    event.preventDefault();
    if (event.which === 13) {
      if (event.target.name === "fechaven") {
        event.target.value = moment(event.target.value).format("YYYY-MM-DD");
        cmbTipoMovimiento.current.focus();
      } else if (event.target.name === "fecha") {
        event.target.value = moment(event.target.value).format("YYYY-MM-DD");
        if (habilitadoFac) {
          txtNumFactura.current.focus();
        } else {
          btnAcepta.current.focus();
        }
      }
      if (event.target.name === "numfactura") {
        btnAcepta.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.name === "fechaven") {
        event.target.value = moment(event.target.value).format("YYYY-MM-DD");
      } else if (event.target.name === "fecha") {
        event.target.value = moment(event.target.value).format("YYYY-MM-DD");
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const validarCantidadP = (event) => {
    event.preventDefault();
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      let cantidades = validarCantidad({
        index: 0,
        event: event,
        productos: [producto],
        tipo: props.tipo,
      });

      setMensaje(cantidades.msm);
      setProducto(cantidades.data[0]);

      if (cantidades.msm.mostrar) {
        btnCancelar.current.focus();
      } else {
        if (event.which === 13) {
          txtFechaVenc.current.focus();
        }
      }
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    let valido = true;
    if (txtIdproducto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El código no debe estar vacio",
        ICONO: "INFORMACION",
      });
      valido = false;
      txtIdproducto.current.focus();
    } else if (txtNombre.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Descripción del Producto no debe estar vacia",
        ICONO: "INFORMACION",
      });
      valido = false;
      txtNombre.current.focus();
    } else if (txtCantidad.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Cantidad no debe estar vacio",
        ICONO: "INFORMACION",
      });
      valido = false;
      txtCantidad.current.focus();
    } else if (txtCantidad.current.value.trim() === "0,00") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Cantidad no debe cero",
        ICONO: "INFORMACION",
      });
      valido = false;
      txtCantidad.current.focus();
    } else if (
      props.tipo >= 2 &&
      parseFloat(txtCantidad.current.value.replace(".", "").replace(",", ".")) >
      parseFloat(
        txtCantidadExistente.current.value.replace(".", "").replace(",", ".")
      )
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La  cantidad no debe ser mayor a la cantidad existente",
        ICONO: "INFORMACION",
      });
      valido = false;
      txtCantidad.current.focus();
    } else if (txtPrecio.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Precio no debe estar vacio",
        ICONO: "INFORMACION",
      });
      valido = false;
      txtPrecio.current.focus();
    } else if (
      (props.tipo >= 2) &
      (txtFecha.current.value.trim() === "") &
      (cmbTipoMovimiento.current.selectedIndex === 0)
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha no debe estar vacia",
        ICONO: "INFORMACION",
      });
      valido = false;
      txtFecha.current.focus();
    } else if (
      (txtFecha.current.value.trim() === "") &
      (cmbTipoMovimiento.current.selectedIndex >= 1)
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha no debe estar vacia",
        ICONO: "INFORMACION",
      });
      valido = false;
      txtFecha.current.focus();
    } else if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha no debe estar vacia",
        ICONO: "INFORMACION",
      });
      valido = false;
      txtFecha.current.focus();
    } else if ((txtNumFactura.current.value.trim() === "") & habilitadoFac) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Numero de factura no debe estar vacio",
        ICONO: "INFORMACION",
      });
      valido = false;
      txtNumFactura.current.focus();
    }

    if (valido) {
      let datos = [];
      datos.push({
        idproducto: producto.idproducto,
        codigo: producto.codigo,
        nombre: producto.nombrecorto,
        cantidad: parseFloat(
          txtCantidad.current.value.replace(".", "").replace(",", ".")
        ),
        precio: tipoIngr === 1 || tipoIngr === 5 ? producto.costo : producto.precio,
        fechavencimiento: txtFechaVenc.current.value,
        tipomovimiento:
          cmbTipoMovimiento.current[cmbTipoMovimiento.current.selectedIndex]
            .text,
        fechatipomovimiento: txtFecha.current.value,
        numfactura: txtNumFactura.current.value,
        tipounidad: producto.tipounidad,
        idunidadmedida: producto.idunidadmedida,
        idunidadalterna: producto.idunidadalterna,
        descripcionuni: producto.descripcionuni,
        descripcionunialt: producto.descripcionunialt,
        tipofactor: producto.tipofactor,
        valorfactor: producto.valorfactor,
        valormoneda: producto.valormoneda,
      });

      setBody(datos);

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: "Esta Seguro de Agregar este Producto.",
        icono: "confirmacion",
      });
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideAcepta(body);
    blanquear();
  };

  const blanquear = () => {
    setActivate(false);
    setOperacion(0);
    setTipoIngreso([]);
    setLabelFecha("FECHA:");
    setUnidadCombo([]);
    setUnidadc();
    setTipoIngr();
    setTipounidadc(1);
    setProducto({
      idproducto: null,
      codigo: null,
      cantidad: 1.0,
      cantidadE: 0.0,
      cantidadEA: 0.0,
      nombrecorto: null,
      precio: 0.0,
      preciomaxi: 0.0,
      precioofe: 0.0,
      preciomayor: 0.0,
      preciomini: 0.0,
      preciomaxialter: 0.0,
      precioofealter: 0.0,
      preciomayoralter: 0.0,
      preciominialter: 0.0,
      preciobs: 0.0,
      iva: 0.0,
      montoiva: 0.0,
      descuento: 0.0,
      total: 0.0,
      unidad: [],
      idunidadmedida: null,
      idunidadalterna: null,
      descripcionuni: "",
      descripcionunialt: "",
      precioconiva: 0.0,
      idmoneda: null,
      valormoneda: 0.0,
      tipounidad: null,
      tipofactor: null,
      valorfactor: 0.0,
      tipoprecio: null,
      fechavencimiento: null,
      tipomovimiento: null,
      fechatipomovimiento: null,
      numfactura: null,
      costocalculado: 0.00,
      costo: 0.00
    });
    cmbUnidad.current.value = "";
  };

  const habilitarCampoTipoMov = () => {
    switch (parseInt(cmbTipoMovimiento.current.value)) {
      case 1:
        if (props.tipo == 1) {
          setLabelFecha("FECHA:");
          txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          btnAcepta.current.focus();
        } else {
          setLabelFecha("FECHA DE VENTA:");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.focus();
        }

        break;
      case 2:
      case 3:
      case 4:
        if (props.tipo == 1) {
          if (cmbTipoMovimiento.current.selectedIndex === 1) {
            setLabelFecha("FECHA DE DONACION:");
          } else if (cmbTipoMovimiento.current.selectedIndex === 2) {
            setLabelFecha("FECHA DE PRESTAMO:");
          } else {
            setLabelFecha("FECHA DE RESGUARDO:");
          }
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.focus();
        } else if (props.tipo == 3) {
          setLabelFecha("FECHA DE TRASLADO:");
          setHabilitadoFec(true);
          setHabilitadoFac(true);
          txtFecha.current.focus();
        } else {
          if (cmbTipoMovimiento.current.selectedIndex === 1) {
            setLabelFecha("FECHA DE VENCIMIENTO:");
          } else if (cmbTipoMovimiento.current.selectedIndex === 2) {
            setLabelFecha("FECHA DE DEVOLUCION:");
          } else {
            setLabelFecha("FECHA DE PRESTAMO:");
          }
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.focus();
        }

        break;

      case 5:
        if (props.tipo == 1) {
          setLabelFecha("FECHA DE ADQUISICION:");
          setHabilitadoFec(true);
          setHabilitadoFac(true);
          txtFecha.current.focus();
        } else {
          setLabelFecha("FECHA DE DONACION:");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.focus();
        }

        break;

      case 6:
        if (props.tipo == 1) {
          setLabelFecha("FECHA DE PRODUCCION:");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.focus();
        } else if (props.tipo == 2) {
          setLabelFecha("FECHA DE AJUSTE:");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.focus();
        }
        break;
      case 7:
        if (props.tipo == 1) {
          setLabelFecha("FECHA DE AJUSTE:");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.focus();
        }
        break;
    }
  };

  const onChange = (e) => {
    if (e.target.name === "tipom") {
      habilitarCampoTipoMov();
      if (e.target.value === '1' || e.target.value === '5') {
        setTipoIngr(parseInt(e.target.value));
        let data = producto;
        let precio = 0.0;
        let montoiva = 0.0;
        let montoivacosto = 0.0;
        let tipounidad = 0;
        let cantie = data.cantidadEA;
        let idunidad = unidadc;
        let costo = 0.00;

        if (parseInt(idunidad) === parseInt(data.idunidadalterna)) {
          tipounidad = 1;
          cantie = parseFloat(data.cantidadEA);
          cantie = Math.trunc(cantie);

          if (parseInt(data.metodocosto) === 1) {
            costo = data.costoproveedor / data.valorfactor;
          }
          if (parseInt(data.metodocosto) === 2) {
            costo = data.costocalculado / data.valorfactor;
          }
          if (parseInt(data.metodocosto) === 3) {
            costo = data.ultimocosto / data.valorfactor;
          }
          if (parseInt(data.metodocosto) === 4) {
            costo = data.costopromedio / data.valorfactor;
          }

          if (parseInt(data.tipoprecio) === 1) {
            precio = parseFloat(data.preciomaxialter);
          } else if (parseInt(data.tipoprecio) === 2) {
            precio = parseFloat(data.precioofealter);
          } else if (parseInt(data.tipoprecio) === 3) {
            precio = parseFloat(data.preciomayoralter);
          } else if (parseInt(data.tipoprecio) === 4) {
            precio = parseFloat(data.preciominialter);
          }

        } else if (parseInt(idunidad) === parseInt(data.idunidadmedida)) {
          tipounidad = 0;
          cantie = parseFloat(data.cantidadEA / data.valorfactor);
          cantie = Math.trunc(cantie);

          if (parseInt(data.metodocosto) === 1) {
            costo = data.costoproveedor;
          }
          if (parseInt(data.metodocosto) === 2) {
            costo = data.costocalculado;
          }
          if (parseInt(data.metodocosto) === 3) {
            costo = data.ultimocosto;
          }
          if (parseInt(data.metodocosto) === 4) {
            costo = data.costopromedio;
          }

          if (parseInt(data.tipoprecio) === 1) {
            precio = parseFloat(data.preciomaxi);
          } else if (parseInt(data.tipoprecio) === 2) {
            precio = parseFloat(data.precioofe);
          } else if (parseInt(data.tipoprecio) === 3) {
            precio = parseFloat(data.preciomayor);
          } else if (parseInt(data.tipoprecio) === 4) {
            precio = parseFloat(data.preciomini);
          }

        }

        montoiva = (precio * parseFloat(data.iva)) / 100;
        montoiva = round(montoiva, 2);

        montoivacosto = (costo * parseFloat(data.iva)) / 100;
        montoivacosto = round(montoivacosto, 2);

        if (props.tipo === 2 || props.tipo === 3) {
          if (parseFloat(data.cantidad) > cantie) {
            data.cantidad = 1.0;
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "La  cantidad no debe ser mayor a la cantidad existente",
              icono: "informacion",
            });
          }
        }

        data.tipounidad = tipounidad;
        data.precio = precio + montoiva;
        data.total = precio * data.cantidad;
        data.montoiva = montoiva * data.cantidad;
        data.cantidadE = cantie;
        data.costo = parseFloat(costo) + montoivacosto;

        setProducto(data);

        cmbUnidad.current.value = idunidad;

        txtCantidadExistente.current.value = formatMoneda(
          cantie.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
        let topreciiva = precio + montoiva;
        txtPrecio.current.value = formatMoneda(
          topreciiva.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
        let precicosto = parseFloat(costo) + montoivacosto;
        txtCosto.current.value = formatMoneda(
          precicosto.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
      } else {
        setTipoIngr(parseInt(e.target.value));
        let data = producto;
        let precio = 0.0;
        let montoiva = 0.0;
        let montoivacosto = 0.0;
        let tipounidad = 0;
        let cantie = data.cantidadEA;
        let idunidad = unidadc;
        let costo = 0.00;

        if (parseInt(idunidad) === parseInt(data.idunidadalterna)) {
          tipounidad = 1;
          cantie = parseFloat(data.cantidadEA);
          cantie = Math.trunc(cantie);

          if (parseInt(data.metodocosto) === 1) {
            costo = data.costoproveedor / data.valorfactor;
          }
          if (parseInt(data.metodocosto) === 2) {
            costo = data.costocalculado / data.valorfactor;
          }
          if (parseInt(data.metodocosto) === 3) {
            costo = data.ultimocosto / data.valorfactor;
          }
          if (parseInt(data.metodocosto) === 4) {
            costo = data.costopromedio / data.valorfactor;
          }

          if (parseInt(data.tipoprecio) === 1) {
            precio = parseFloat(data.preciomaxialter);
          } else if (parseInt(data.tipoprecio) === 2) {
            precio = parseFloat(data.precioofealter);
          } else if (parseInt(data.tipoprecio) === 3) {
            precio = parseFloat(data.preciomayoralter);
          } else if (parseInt(data.tipoprecio) === 4) {
            precio = parseFloat(data.preciominialter);
          }

        } else if (parseInt(idunidad) === parseInt(data.idunidadmedida)) {
          tipounidad = 0;
          cantie = parseFloat(data.cantidadEA / data.valorfactor);
          cantie = Math.trunc(cantie);

          if (parseInt(data.metodocosto) === 1) {
            costo = data.costoproveedor;
          }
          if (parseInt(data.metodocosto) === 2) {
            costo = data.costocalculado;
          }
          if (parseInt(data.metodocosto) === 3) {
            costo = data.ultimocosto;
          }
          if (parseInt(data.metodocosto) === 4) {
            costo = data.costopromedio;
          }

          if (parseInt(data.tipoprecio) === 1) {
            precio = parseFloat(data.preciomaxi);
          } else if (parseInt(data.tipoprecio) === 2) {
            precio = parseFloat(data.precioofe);
          } else if (parseInt(data.tipoprecio) === 3) {
            precio = parseFloat(data.preciomayor);
          } else if (parseInt(data.tipoprecio) === 4) {
            precio = parseFloat(data.preciomini);
          }

        }

        montoiva = (precio * parseFloat(data.iva)) / 100;
        montoiva = round(montoiva, 2);

        montoivacosto = (costo * parseFloat(data.iva)) / 100;
        montoivacosto = round(montoivacosto, 2);

        if (props.tipo === 2 || props.tipo === 3) {
          if (parseFloat(data.cantidad) > cantie) {
            data.cantidad = 1.0;
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "La  cantidad no debe ser mayor a la cantidad existente",
              icono: "informacion",
            });
          }
        }

        data.tipounidad = tipounidad;
        data.precio = precio + montoiva;
        data.total = precio * data.cantidad;
        data.montoiva = montoiva * data.cantidad;
        data.cantidadE = cantie;
        data.costo = parseFloat(costo) + montoivacosto;

        setProducto(data);

        cmbUnidad.current.value = idunidad;

        txtCantidadExistente.current.value = formatMoneda(
          cantie.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
        let topreciiva = precio + montoiva;
        txtPrecio.current.value = formatMoneda(
          topreciiva.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
        let precicosto = parseFloat(costo) + montoivacosto;
        txtCosto.current.value = formatMoneda(
          precicosto.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
      }
    }
  };

  const onCambioUnidad = (e) => {

    if (e.target.name === 'tipou') {
      let data = producto;
      let precio = 0.0;
      let costo = 0.0;
      let montoiva = 0.0;
      let montoivacosto = 0.0;
      let tipounidad = 0;
      let cantie = data.cantidadEA;
      let idunidad = e.target.value;
      setTipounidadc(e.target.value);

      if (parseInt(idunidad) === parseInt(data.idunidadalterna)) {
        tipounidad = 1;
        cantie = parseFloat(data.cantidadEA);
        cantie = Math.trunc(cantie);

        if (tipoIngr === 1 || tipoIngr === 5) {
          if (parseInt(data.metodocosto) === 1) {
            costo = data.costoproveedor / data.valorfactor;
          }
          if (parseInt(data.metodocosto) === 2) {
            costo = data.costocalculado / data.valorfactor;
          }
          if (parseInt(data.metodocosto) === 3) {
            costo = data.ultimocosto / data.valorfactor;
          }
          if (parseInt(data.metodocosto) === 4) {
            costo = data.costopromedio / data.valorfactor;
          }

          if (parseInt(data.tipoprecio) === 1) {
            precio = parseFloat(data.preciomaxialter);
          } else if (parseInt(data.tipoprecio) === 2) {
            precio = parseFloat(data.precioofealter);
          } else if (parseInt(data.tipoprecio) === 3) {
            precio = parseFloat(data.preciomayoralter);
          } else if (parseInt(data.tipoprecio) === 4) {
            precio = parseFloat(data.preciominialter);
          }
        } else {
          if (parseInt(data.metodocosto) === 1) {
            costo = data.costoproveedor / data.valorfactor;
          }
          if (parseInt(data.metodocosto) === 2) {
            costo = data.costocalculado / data.valorfactor;
          }
          if (parseInt(data.metodocosto) === 3) {
            costo = data.ultimocosto / data.valorfactor;
          }
          if (parseInt(data.metodocosto) === 4) {
            costo = data.costopromedio / data.valorfactor;
          }

          if (parseInt(data.tipoprecio) === 1) {
            precio = parseFloat(data.preciomaxialter);
          } else if (parseInt(data.tipoprecio) === 2) {
            precio = parseFloat(data.precioofealter);
          } else if (parseInt(data.tipoprecio) === 3) {
            precio = parseFloat(data.preciomayoralter);
          } else if (parseInt(data.tipoprecio) === 4) {
            precio = parseFloat(data.preciominialter);
          }
        }
        setUnidadc(e.target.value);
      } else if (parseInt(idunidad) === parseInt(data.idunidadmedida)) {
        tipounidad = 0;
        cantie = parseFloat(data.cantidadEA / data.valorfactor);
        cantie = Math.trunc(cantie);

        if (tipoIngr === 1 || tipoIngr === 5) {
          if (parseInt(data.metodocosto) === 1) {
            costo = data.costoproveedor;
          }
          if (parseInt(data.metodocosto) === 2) {
            costo = data.costocalculado;
          }
          if (parseInt(data.metodocosto) === 3) {
            costo = data.ultimocosto;
          }
          if (parseInt(data.metodocosto) === 4) {
            costo = data.costopromedio;
          }

          if (parseInt(data.tipoprecio) === 1) {
            precio = parseFloat(data.preciomaxi);
          } else if (parseInt(data.tipoprecio) === 2) {
            precio = parseFloat(data.precioofe);
          } else if (parseInt(data.tipoprecio) === 3) {
            precio = parseFloat(data.preciomayor);
          } else if (parseInt(data.tipoprecio) === 4) {
            precio = parseFloat(data.preciomini);
          }
        } else {
          if (parseInt(data.metodocosto) === 1) {
            costo = data.costoproveedor;
          }
          if (parseInt(data.metodocosto) === 2) {
            costo = data.costocalculado;
          }
          if (parseInt(data.metodocosto) === 3) {
            costo = data.ultimocosto;
          }
          if (parseInt(data.metodocosto) === 4) {
            costo = data.costopromedio;
          }

          if (parseInt(data.tipoprecio) === 1) {
            precio = parseFloat(data.preciomaxi);
          } else if (parseInt(data.tipoprecio) === 2) {
            precio = parseFloat(data.precioofe);
          } else if (parseInt(data.tipoprecio) === 3) {
            precio = parseFloat(data.preciomayor);
          } else if (parseInt(data.tipoprecio) === 4) {
            precio = parseFloat(data.preciomini);
          }
        }
        setUnidadc(e.target.value);
      }

      montoivacosto = (costo * parseFloat(data.iva)) / 100;
      montoivacosto = round(montoivacosto, 2);

      montoiva = (precio * parseFloat(data.iva)) / 100;
      montoiva = round(montoiva, 2);

      if (props.tipo === 2 || props.tipo === 3) {
        if (parseFloat(data.cantidad) > cantie) {
          data.cantidad = 1.0;
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "La  cantidad no debe ser mayor a la cantidad existente",
            icono: "informacion",
          });
        }
      }

      data.tipounidad = tipounidad;
      data.precio = precio;
      data.total = precio * data.cantidad;
      data.montoiva = montoiva * data.cantidad;
      data.cantidadE = cantie;
      data.costo = parseFloat(costo) + montoivacosto;

      setProducto(data);

      cmbUnidad.current.value = idunidad;

      txtCantidadExistente.current.value = formatMoneda(
        cantie.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
      let topreciiva = precio + montoiva;
      let precicosto = parseFloat(costo) + montoivacosto;
      txtPrecio.current.value = formatMoneda(
        topreciiva.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
      txtCosto.current.value = formatMoneda(
        precicosto.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }

  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const seleccionarProductoInv = (tecla, idubi) => {
    let codigoproduct = "'" + txtIdproducto.current.value.toUpperCase() + "'";
    let endpoint = `${op.conexion}/api/inventario/seleccionarproductoinv?idproducto=${codigoproduct}&idalmacen=${idubi}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let prod;
          if (response.data !== "") {
            if (response.data.servicio) {
              setMensaje({
                mostrar: true,
                titulo: "Notificacion",
                texto: "no existe un producto con ese codigo en el almacen.",
                icono: "error",
              });
            } else {
              if (operacion === 1) {
                for (let i = 0; i < props.productos.length; i++) {
                  if (
                    props.productos[i].codigo ===
                    txtIdproducto.current.value.toUpperCase()
                  ) {
                    setActivate(false);
                    setMensaje({
                      mostrar: true,
                      titulo: "Notificacion",
                      texto: "El PRODUCTO YA EXISTE",
                      icono: "error",
                    });
                    txtIdproducto.current.value = "";
                    txtPrecio.current.value = "0,00";
                    txtCosto.current.value = "0,00";
                    txtIdproducto.current.focus();
                    txtCantidadExistente.current.value = "0,00";
                    txtCantidad.current.value = "0,00";
                    return;
                  }
                }
              }

              let uni = [];
              let precio = 0.0;
              let costo = 0.00;
              let montoiva = 0.0;
              let montoivacosto = 0.0;
              let cantie = response.data.cantidad;
              let tipouni = 0;
              let tiene_iva = false;
              let tipoprecio = parseInt(response.data.tipoprecio);

              if (parseFloat(response.data.ivaventa) > 0.0) {
                tiene_iva = true;
              }

              if (
                parseInt(response.data.tipofactor) === 0 ||
                response.data.tipofactor === null
              ) {
                tipouni = 0;
                uni = [
                  {
                    idunidad: response.data.idunidadmedida,
                    descripcion: response.data.descripcionuni,
                    tipo: "medida",
                  },
                ];

                cantie = parseFloat(response.data.cantidad);
                cantie = Math.trunc(cantie);

                if (tipoIngr === 1) {
                  if (parseInt(response.data.metodocosto) === 1) {
                    costo = response.data.costoproveedor;
                  }
                  if (parseInt(response.data.metodocosto) === 2) {
                    costo = response.data.costocalculado;
                  }
                  if (parseInt(response.data.metodocosto) === 3) {
                    costo = response.data.ultimocosto;
                  }
                  if (parseInt(response.data.metodocosto) === 4) {
                    costo = response.data.costopromedio;
                  }

                  if (tipoprecio === 1) {
                    precio = parseFloat(response.data.preciomaxi);
                  } else if (tipoprecio === 2) {
                    precio = parseFloat(response.data.precioofe);
                  } else if (tipoprecio === 3) {
                    precio = parseFloat(response.data.preciomayor);
                  } else if (tipoprecio === 4) {
                    precio = parseFloat(response.data.preciomini);
                  }
                } else {
                  if (parseInt(response.data.metodocosto) === 1) {
                    costo = response.data.costoproveedor;
                  }
                  if (parseInt(response.data.metodocosto) === 2) {
                    costo = response.data.costocalculado;
                  }
                  if (parseInt(response.data.metodocosto) === 3) {
                    costo = response.data.ultimocosto;
                  }
                  if (parseInt(response.data.metodocosto) === 4) {
                    costo = response.data.costopromedio;
                  }

                  if (tipoprecio === 1) {
                    precio = parseFloat(response.data.preciomaxi);
                  } else if (tipoprecio === 2) {
                    precio = parseFloat(response.data.precioofe);
                  } else if (tipoprecio === 3) {
                    precio = parseFloat(response.data.preciomayor);
                  } else if (tipoprecio === 4) {
                    precio = parseFloat(response.data.preciomini);
                  }
                }
                montoivacosto = (costo * response.data.ivaventa) / 100;
                montoiva = (precio * response.data.ivaventa) / 100;
              } else {
                if (tipounidadc !== 1) {
                  if (tipounidadc === response.data.idunidadalterna) {
                    tipouni = 1;
                    uni = [
                      {
                        idunidad: response.data.idunidadmedida,
                        descripcion: response.data.descripcionuni,
                        tipo: "medida",
                      },
                      {
                        idunidad: response.data.idunidadalterna,
                        descripcion: response.data.descripcionunialt,
                        tipo: "alterna",
                      },
                    ];

                    cantie = parseFloat(response.data.cantidad);
                    cantie = Math.trunc(cantie);

                    if (tipoIngr === 1) {
                      if (parseInt(response.data.metodocosto) === 1) {
                        costo = response.data.costoproveedor / response.data.valorfactor;
                      }
                      if (parseInt(response.data.metodocosto) === 2) {
                        costo = response.data.costocalculado / response.data.valorfactor;
                      }
                      if (parseInt(response.data.metodocosto) === 3) {
                        costo = response.data.ultimocosto / response.data.valorfactor;
                      }
                      if (parseInt(response.data.metodocosto) === 4) {
                        costo = response.data.costopromedio / response.data.valorfactor;
                      }

                      if (tipoprecio === 1) {
                        precio = parseFloat(response.data.preciomaxialter);
                      } else if (tipoprecio === 2) {
                        precio = parseFloat(response.data.precioofealter);
                      } else if (tipoprecio === 3) {
                        precio = parseFloat(response.data.preciomayoralter);
                      } else if (tipoprecio === 4) {
                        precio = parseFloat(response.data.preciominialter);
                      }
                    } else {
                      if (parseInt(response.data.metodocosto) === 1) {
                        costo = response.data.costoproveedor / response.data.valorfactor;
                      }
                      if (parseInt(response.data.metodocosto) === 2) {
                        costo = response.data.costocalculado / response.data.valorfactor;
                      }
                      if (parseInt(response.data.metodocosto) === 3) {
                        costo = response.data.ultimocosto / response.data.valorfactor;
                      }
                      if (parseInt(response.data.metodocosto) === 4) {
                        costo = response.data.costopromedio / response.data.valorfactor;
                      }

                      if (tipoprecio === 1) {
                        precio = parseFloat(response.data.preciomaxialter);
                      } else if (tipoprecio === 2) {
                        precio = parseFloat(response.data.precioofealter);
                      } else if (tipoprecio === 3) {
                        precio = parseFloat(response.data.preciomayoralter);
                      } else if (tipoprecio === 4) {
                        precio = parseFloat(response.data.preciominialter);
                      }
                    }
                    montoivacosto = (costo * response.data.ivaventa) / 100;
                    montoiva = (precio * response.data.ivaventa) / 100;
                  } else if (tipounidadc === response.data.idunidadmedida) {
                    tipouni = 0;
                    uni = [
                      {
                        idunidad: response.data.idunidadmedida,
                        descripcion: response.data.descripcionuni,
                        tipo: "medida",
                      },
                      {
                        idunidad: response.data.idunidadalterna,
                        descripcion: response.data.descripcionunialt,
                        tipo: "alterna",
                      },
                    ];

                    cantie = parseFloat(
                      response.data.cantidad / response.data.valorfactor
                    );
                    cantie = Math.trunc(cantie);

                    if (tipoIngr === 1) {
                      if (parseInt(response.data.metodocosto) === 1) {
                        costo = response.data.costoproveedor;
                      }
                      if (parseInt(response.data.metodocosto) === 2) {
                        costo = response.data.costocalculado;
                      }
                      if (parseInt(response.data.metodocosto) === 3) {
                        costo = response.data.ultimocosto;
                      }
                      if (parseInt(response.data.metodocosto) === 4) {
                        costo = response.data.costopromedio;
                      }

                      if (tipoprecio === 1) {
                        precio = parseFloat(response.data.preciomaxi);
                      } else if (tipoprecio === 2) {
                        precio = parseFloat(response.data.precioofe);
                      } else if (tipoprecio === 3) {
                        precio = parseFloat(response.data.preciomayor);
                      } else if (tipoprecio === 4) {
                        precio = parseFloat(response.data.preciomini);
                      }
                    } else {
                      if (parseInt(response.data.metodocosto) === 1) {
                        costo = response.data.costoproveedor;
                      }
                      if (parseInt(response.data.metodocosto) === 2) {
                        costo = response.data.costocalculado;
                      }
                      if (parseInt(response.data.metodocosto) === 3) {
                        costo = response.data.ultimocosto;
                      }
                      if (parseInt(response.data.metodocosto) === 4) {
                        costo = response.data.costopromedio;
                      }

                      if (tipoprecio === 1) {
                        precio = parseFloat(response.data.preciomaxi);
                      } else if (tipoprecio === 2) {
                        precio = parseFloat(response.data.precioofe);
                      } else if (tipoprecio === 3) {
                        precio = parseFloat(response.data.preciomayor);
                      } else if (tipoprecio === 4) {
                        precio = parseFloat(response.data.preciomini);
                      }
                    }
                    montoivacosto = (costo * response.data.ivaventa) / 100;
                    montoiva = (precio * response.data.ivaventa) / 100;
                  }
                } else {
                  if (
                    response.data.idunidadventa === response.data.idunidadalterna
                  ) {
                    tipouni = 1;
                    uni = [
                      {
                        idunidad: response.data.idunidadalterna,
                        descripcion: response.data.descripcionunialt,
                        tipo: "alterna",
                      },
                      {
                        idunidad: response.data.idunidadmedida,
                        descripcion: response.data.descripcionuni,
                        tipo: "medida",
                      },
                    ];

                    cantie = parseFloat(response.data.cantidad);
                    cantie = Math.trunc(cantie);

                    if (tipoIngr === 1) {
                      if (parseInt(response.data.metodocosto) === 1) {
                        costo = response.data.costoproveedor / response.data.valorfactor;
                      }
                      if (parseInt(response.data.metodocosto) === 2) {
                        costo = response.data.costocalculado / response.data.valorfactor;
                      }
                      if (parseInt(response.data.metodocosto) === 3) {
                        costo = response.data.ultimocosto / response.data.valorfactor;
                      }
                      if (parseInt(response.data.metodocosto) === 4) {
                        costo = response.data.costopromedio / response.data.valorfactor;
                      }

                      if (tipoprecio === 1) {
                        precio = parseFloat(response.data.preciomaxialter);
                      } else if (tipoprecio === 2) {
                        precio = parseFloat(response.data.precioofealter);
                      } else if (tipoprecio === 3) {
                        precio = parseFloat(response.data.preciomayoralter);
                      } else if (tipoprecio === 4) {
                        precio = parseFloat(response.data.preciominialter);
                      }
                    } else {
                      if (parseInt(response.data.metodocosto) === 1) {
                        costo = response.data.costoproveedor / response.data.valorfactor;
                      }
                      if (parseInt(response.data.metodocosto) === 2) {
                        costo = response.data.costocalculado / response.data.valorfactor;
                      }
                      if (parseInt(response.data.metodocosto) === 3) {
                        costo = response.data.ultimocosto / response.data.valorfactor;
                      }
                      if (parseInt(response.data.metodocosto) === 4) {
                        costo = response.data.costopromedio / response.data.valorfactor;
                      }

                      if (tipoprecio === 1) {
                        precio = parseFloat(response.data.preciomaxialter);
                      } else if (tipoprecio === 2) {
                        precio = parseFloat(response.data.precioofealter);
                      } else if (tipoprecio === 3) {
                        precio = parseFloat(response.data.preciomayoralter);
                      } else if (tipoprecio === 4) {
                        precio = parseFloat(response.data.preciominialter);
                      }
                    }
                    montoivacosto = (costo * response.data.ivaventa) / 100;
                    montoiva = (precio * response.data.ivaventa) / 100;
                  } else if (
                    response.data.idunidadventa === response.data.idunidadmedida
                  ) {
                    tipouni = 0;
                    uni = [
                      {
                        idunidad: response.data.idunidadmedida,
                        descripcion: response.data.descripcionuni,
                        tipo: "medida",
                      },
                      {
                        idunidad: response.data.idunidadalterna,
                        descripcion: response.data.descripcionunialt,
                        tipo: "alterna",
                      },
                    ];

                    cantie = parseFloat(
                      response.data.cantidad / response.data.valorfactor
                    );
                    cantie = Math.trunc(cantie);

                    if (tipoIngr === 1) {
                      if (parseInt(response.data.metodocosto) === 1) {
                        costo = response.data.costoproveedor;
                      }
                      if (parseInt(response.data.metodocosto) === 2) {
                        costo = response.data.costocalculado;
                      }
                      if (parseInt(response.data.metodocosto) === 3) {
                        costo = response.data.ultimocosto;
                      }
                      if (parseInt(response.data.metodocosto) === 4) {
                        costo = response.data.costopromedio;
                      }

                      if (tipoprecio === 1) {
                        precio = parseFloat(response.data.preciomaxi);
                      } else if (tipoprecio === 2) {
                        precio = parseFloat(response.data.precioofe);
                      } else if (tipoprecio === 3) {
                        precio = parseFloat(response.data.preciomayor);
                      } else if (tipoprecio === 4) {
                        precio = parseFloat(response.data.preciomini);
                      }
                    } else {
                      if (parseInt(response.data.metodocosto) === 1) {
                        costo = response.data.costoproveedor;
                      }
                      if (parseInt(response.data.metodocosto) === 2) {
                        costo = response.data.costocalculado;
                      }
                      if (parseInt(response.data.metodocosto) === 3) {
                        costo = response.data.ultimocosto;
                      }
                      if (parseInt(response.data.metodocosto) === 4) {
                        costo = response.data.costopromedio;
                      }

                      if (tipoprecio === 1) {
                        precio = parseFloat(response.data.preciomaxi);
                      } else if (tipoprecio === 2) {
                        precio = parseFloat(response.data.precioofe);
                      } else if (tipoprecio === 3) {
                        precio = parseFloat(response.data.preciomayor);
                      } else if (tipoprecio === 4) {
                        precio = parseFloat(response.data.preciomini);
                      }
                    }
                    montoivacosto = (costo * response.data.ivaventa) / 100;
                    montoiva = (precio * response.data.ivaventa) / 100;
                  }

                }
              }

              setUnidadCombo(uni);
              setUnidadc(response.data.idunidadventa);
              let topreciiva = precio + montoiva;
              let precicosto = parseFloat(costo) + montoivacosto;
              txtNombre.current.value = response.data.nombre.trim();
              txtPrecio.current.value = formatMoneda(
                topreciiva.toString().replace(",", "").replace(".", ","),
                ",",
                ".",
                2
              );
              txtCosto.current.value = formatMoneda(
                precicosto.toString().replace(",", "").replace(".", ","),
                ",",
                ".",
                2
              );
              txtCantidadExistente.current.value = formatMoneda(
                cantie.toString().replace(",", "").replace(".", ","),
                ",",
                ".",
                2
              );
              if (tecla === 13) {
                txtCantidad.current.focus();
              }

              prod = {
                idproducto: response.data.idproducto,
                codigo: response.data.codigo,
                cantidad: 1.0,
                cantidadE: cantie,
                cantidadEA: parseFloat(response.data.cantidad),
                nombrecorto: `${response.data.nombrecorto} ${tiene_iva ? "" : " (E)"
                  }`,
                precio: topreciiva,
                precious: precio,
                preciobs: 0.0,
                iva: response.data.ivaventa,
                preciomaxi: response.data.preciomaxi,
                precioofe: response.data.precioofe,
                preciomayor: response.data.preciomayor,
                preciomini: response.data.preciomini,
                preciomaxialter: response.data.preciomaxialter,
                precioofealter: response.data.precioofealter,
                preciomayoralter: response.data.preciomayoralter,
                preciominialter: response.data.preciominialter,
                costoproveedor: response.data.costoproveedor,
                costocalculado: response.data.costocalculado,
                ultimocosto: response.data.ultimocosto,
                costopromedio: response.data.costopromedio,
                montoiva: montoiva,
                descuento: 0.0,
                total: precio,
                unidad: uni,
                idunidadmedida: response.data.idunidadmedida,
                idunidadalterna: response.data.idunidadalterna,
                descripcionuni: response.data.descripcionuni,
                descripcionunialt: response.data.descripcionunialt,
                idmoneda: response.data.idmoneda,
                valormoneda: response.data.valormoneda,
                tipounidad: tipouni,
                tipofactor: response.data.tipofactor,
                valorfactor: response.data.valorfactor,
                costocalculado: response.data.costocalculado,
                costo: precicosto,
                metodocosto: parseInt(response.data.metodocosto),
                tipoprecio: tipoprecio,
                precioconiva: round(
                  parseFloat((precio * response.data.ivaventa) / 100) +
                  parseFloat(precio),
                  2
                ),
              };

              setProducto(prod);
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "no existe un producto con ese codigo en el almacen.",
              icono: "error",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarProducto = (event) => {
    event.preventDefault();
    txtNombre.current.value = "";
    txtPrecio.current.value = "0,00";
    txtCantidadExistente.current.value = "0,00";
    txtCantidad.current.value = "0,00";
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarProductoInv(event.which, props.idalmacen);
      }
    }
  };

  const onCatalogoProducto = (values) => {
    setCatalogoProducto(false);
    setCatalogoProductoE(false);
    txtIdproducto.current.value = values.codigo;
    if (props.tipo === 1) {
      seleccionarProductoInv(13, props.idalmacen);
    } else {
      seleccionarProductoInv(13, values.idalmacen);
    }
  };


  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  useEffect(() => {
    if (props.tipoingreso) {
      setTipoIngreso(props.tipoingreso);
    }
  }, [props.tipoingreso]);

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      style={{ backgroundColor: "rgb(0, 0, 0,0.5)" }}
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion === 1) {
          txtIdproducto.current.focus();
        } else {
          txtIdproducto.current.value = props.registro.idproducto;
          txtCantidad.current.value = formatMoneda(
            props.registro.cantidad
              .toString()
              .replace(",", "")
              .replace(".", ","),
            ",",
            ".",
            2
          );
          txtFechaVenc.current.value =
            props.registro.fechavencimiento === ""
              ? ""
              : moment(props.registro.fechavencimiento).format("DD/MM/YYYY");
          txtFecha.current.value =
            props.registro.fechatipomovimiento === ""
              ? ""
              : moment(props.registro.fechatipomovimiento).format("DD/MM/YYYY");
          txtNumFactura.current.value = props.registro.numfactura.trim();
          for (let i = 0; i < props.tipoingreso.length; i++) {
            if (
              props.tipoingreso[i].descripcion === props.registro.tipomovimiento
            ) {
              cmbTipoMovimiento.current.selectedIndex = i; //props.tipoingreso[i].idtipo;
              break;
            }
          }
          habilitarCampoTipoMov();
          //txtCantidad.current.focus();
          seleccionarProductoInv(13, props.idalmacen);
        }
        setTipoIngreso(props.tipoingreso);
        setTipoIngr(1);
        if (props.tipo === 1) {
          // txtFecha.current.value = "";
          txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
        } else if (props.tipo == 3) {
          setLabelFecha("FECHA DE TRASLADO:");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
        } else {
          txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
          // txtFecha.current.value = "";
          setHabilitadoFec(true);
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <Modal.Title style={{ color: "#fff" }}>
          {props.operacion === 1
            ? "Agregar Productos."
            : props.operacion === 2
              ? "Editar Productos."
              : props.operacion === 3
                ? "Eliminar Productos."
                : "Consultar Productos."}
        </Modal.Title>
        <button
          ref={btnCancelar}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <CatalogoProductoExistencia
          show={catalogoProductoE}
          onHideCancelar={() => setCatalogoProductoE(false)}
          onHideAceptaCatalogo={onCatalogoProducto}
          idalmacen={props.idalmacen}
        />
        <ModalEditarProductosOperacion
          show={catalogoediproduct}
          idproduct={producto.codigo}
          ope={2}
          onHideCancela={() => setCatalogoediproduct(false)}
          onHideAceptaProduct={onCatalogoProducto}
        />
        <CatalogoProducto
          show={catalogoProducto}
          onHideCancelar={() => setCatalogoProducto(false)}
          onHideAceptaCatalogo={onCatalogoProducto}
        />
        <div className="border-azul py-3 rounded">
          <div style={{ fontFamily: "Times New Roman, Times, serif" }}>
            <div className="row rounded m-0">
              <div className="col-md-12 mb-2">
                <fieldset className=" row col-sm-12 mx-auto border-azul rounded d-lflex justify-content-between">
                  <legend className="float-none w-auto fw-bold">
                    Productos
                  </legend>

                  <div className="input-group mb-2 col-pd-260 px-1">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-default"
                    >
                      CODIGO:
                    </label>
                    <input
                      type="text"
                      ref={txtIdproducto}
                      autoComplete="off"
                      className="form-control text-uppercase h-100 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-default"
                      onChange={(e) =>
                        (e.target.value = e.target.value.toUpperCase())
                      }
                      onKeyUp={validarProducto}
                      onBlur={validarProducto}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        if (props.tipo === 1) {
                          setCatalogoProducto(true);
                        } else {
                          setCatalogoProductoE(true);
                        }
                      }}
                      className="btn btn-success"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>

                  <div className="input-group mb-2 col-pd-700 px-0">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-default"
                    >
                      DESCRIPCION:
                    </label>
                    <input
                      type="text"
                      disabled
                      ref={txtNombre}
                      className="form-control h-100 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-default"
                    />
                  </div>
                </fieldset>
              </div>

              <div className="input-group mb-2 col-pd-410 px-1">
                <label
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  TIPO DE MOVIMIENTO:
                </label>
                <select
                  ref={cmbTipoMovimiento}
                  className="form-select px-1 fs-5"
                  aria-label="Default select example"
                  name="tipom"
                  onChange={onChange}
                >
                  {tipoIngreso &&
                    tipoIngreso.map((tipo) => (
                      <option key={tipo.idtipo} value={tipo.idtipo}>
                        {tipo.descripcion}
                      </option>
                    ))}
                </select>
              </div>

              <div className="input-group mb-2 col-pd-300 px-1 mx-auto">
                <label
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  CANTIDAD ACTUAL:
                </label>
                <input
                  type="text"
                  disabled
                  ref={txtCantidadExistente}
                  className="form-control text-right h-100 fs-5"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                  defaultValue={"0,00"}
                />
              </div>

              <div className="input-group mb-2 col-pd-270 px-1 ml-auto">
                <label
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  UNIDAD/MEDIDA:
                </label>
                <select
                  ref={cmbUnidad}
                  className="form-select fs-5"
                  aria-label="Default select example"
                  name="tipou"
                  onChange={onCambioUnidad}
                >
                  {unidadCombo.map((unid, x) => (
                    <option key={x} value={unid.idunidad}>
                      {" "}
                      {unid.descripcion}{" "}
                    </option>
                  ))}
                </select>
              </div>

              <div className="input-group mb-2 col-pd-240 px-1">
                <label
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  CANTIDAD:
                </label>
                <input
                  type="text"
                  ref={txtCantidad}
                  autoComplete="off"
                  className="form-control text-right h-100 fs-5"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                  id="cantidad"
                  onFocus={seleccionarCampo}
                  onKeyUp={validarCantidadP}
                  onBlur={validarCantidadP}
                  defaultValue={"0,00"}
                />
              </div>

              <div className="input-group mb-2 col-pd-210 px-1 mx-auto">
                <label
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  COSTO:
                </label>
                <input
                  type="text"
                  disabled
                  ref={txtCosto}
                  className="form-control text-right h-100 fs-5"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                  defaultValue={"0,00"}
                />
                {producto.idproducto !== null && tipoIngr === 5 ? <button
                  type="button"
                  onClick={() => setCatalogoediproduct(true)}
                  className="btn btn-warning"
                >
                  <i className="fas fa-edit"></i>
                </button> : ''}
              </div>

              <div className="input-group mb-2 col-pd-250 px-1">
                <label
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  PRECIO DE VENTA:
                </label>
                <input
                  type="text"
                  disabled
                  ref={txtPrecio}
                  className="form-control text-right h-100 fs-5"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                  defaultValue={"0,00"}
                />
              </div>

              <div className="input-group mb-2 col-pd-360 px-1 ml-auto">
                <label
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  FECHA/VENCIMIENTO:
                </label>
                <input
                  type="date"
                  ref={txtFechaVenc}
                  className="form-control h-100 fs-5"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                  name="fechaven"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>

              {labelFecha === "FECHA:" ? (
                <div className="input-group mb-2 col-pd-250 px-1">
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-default"
                  >
                    {labelFecha}
                  </label>
                  <input
                    type="date"
                    disabled={!habilitadoFec}
                    ref={txtFecha}
                    defaultValue={moment(fechasistema).format("YYYY-MM-DD")}
                    className="form-control h-100 fs-5"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-default"
                    name="fecha"
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
              ) : (
                <div className="input-group mb-2 col-pd-360 px-1">
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-default"
                  >
                    {labelFecha}
                  </label>
                  <input
                    type="date"
                    disabled={!habilitadoFec}
                    ref={txtFecha}
                    defaultValue={moment(fechasistema).format("YYYY-MM-DD")}
                    className="form-control h-100 fs-5"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-default"
                    name="fecha"
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
              )}

              <div className="input-group mb-2 col-pd-300 px-1">
                <label
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  FACTURA N°:
                </label>
                <input
                  type="text"
                  disabled={labelFecha === 'FECHA DE DONACION:' ? false : true}
                  ref={txtNumFactura}
                  className="form-control text-uppercase h-100 fs-5"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                  name="numfactura"
                  onKeyUp={handleInputChange}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          disabled={operacion === 4 ? true : false}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success "
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancelar}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill "
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/almacen/incluirProducto.js